import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';

export const abortableAppRequest = (url, dataArg) => {
    const controller = new AbortController();
    const signal = controller.signal;

    let data = typeof dataArg === "undefined" ? {} : dataArg;
    return {
        ready: fetch(url, {
            method: "POST",
            headers: {"Accept": "application/json"},
            body: JSON.stringify(data),
            // This option is required to avoid the missing of the cookie PHPSESSID in Chrome 47,
            // which contains the username/companydb vars.
            // https://developer.mozilla.org/fr/docs/Web/API/Request/credentials
            credentials: "same-origin",
            signal
        }).then(resp => {
            return resp.json();
        }).catch(exception => {
            console.log(exception);
            return {valid: false, message: exception}
        }),
        abort: () => controller.abort()
    };
};

export const appRequest = (url, dataArg) => {
    let data = typeof dataArg === "undefined" ? {} : dataArg;
    return fetch(url, {
        method: "POST",
        headers: {"Accept": "application/json"},
        body: JSON.stringify(data),
        // This option is required to avoid the missing of the cookie PHPSESSID in Chrome 47,
        // which contains the username/companydb vars.
        // https://developer.mozilla.org/fr/docs/Web/API/Request/credentials
        credentials: "same-origin"
    })
        .then(resp => {
            return resp.json();
        }).catch(exception => {
            console.log(exception);
            return {valid: false, message: exception}
        });
};

export const appQuery = (url, isJson = true) => {
    return fetch(url, {
        method: "GET",
        headers: {"Accept": "application/json"},
        // This option is required to avoid the missing of the cookie PHPSESSID in Chrome 47,
        // which contains the username/companydb vars.
        // https://developer.mozilla.org/fr/docs/Web/API/Request/credentials
        credentials: "same-origin"
    })
        .then(resp => {
            return isJson ? resp.json() : resp.text();
        }).catch(exception => {
            console.log(exception);
            return {valid: false}
        });
};

export const appFormRequest = (url, body, isJson = false) => {
    return fetch(url, {
        method: "POST",
        headers: {
            "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
            "X-Requested-With": "XMLHttpRequest"
        },
        // This option is required to avoid the missing of the cookie PHPSESSID in Chrome 47,
        // which contains the username/companydb vars.
        // https://developer.mozilla.org/fr/docs/Web/API/Request/credentials
        credentials: "same-origin",
        body: body
    }).then(resp => {
        console.log(resp);
        return isJson ? resp.json() : resp.text();
    })
};


export const delay = (callback, ms) => {
    let timer = 0;
    return function () {
        let context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
};


// WEBPACK FOOTER //
// ./assets/js/utils_request.js